<div class="absolute z-20 top-0 right-0 left-0 pl-8 pr-6 h-12 bg-green-500 text-white w-full flex items-center justify-between font-bold">
    @if (step === 'checkout') {
        <div class="flex items-center gap-2 -m-4">
            <p-button
                icon="pi pi-chevron-left" 
                [rounded]="true" 
                [text]="true" 
                (click)="goBack()"
                class="[&_button]:bg-transparent [&_button]:text-white [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
            <div>Checkout</div>
        </div>

    } @else {
        <div>Grocery Shopping List</div>
    }
    <div>
        <p-button
            icon="pi pi-times" 
            [rounded]="true" 
            [text]="true" 
            (click)="closeDialog()"
            class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
    </div>
</div>
<div #dialogContent class="pt-16 pb-2 h-full flex flex-col justify-between">
    @if(step === 'view-cart') {
        <div class="pb-8">
            @if(groupedCartItems$ | async; as groupedCartItems) {
                @for (group of groupedCartItems | keyvalue; track group) {
                    <div class="mb-2">
                        @if(storeCount > 1){<div class="text-xs text-gray-700 text-bold capitalize">{{group.key || 'Any Store'}}</div>}
                        @for (item of group.value; track item.id) {
                            <div class="p-3 border-bottom-1 border-gray-300 flex flex-row justify-content-between">
                                <div class="flex-1">
                                    <div class="font-medium text-sm"><span class="capitalize">{{ item.name }}</span></div>
                                    <div class="text-sm font-light capitalize">@if(item.quantity){<span>{{item.quantity + ' ' + item.unit}}, </span>} {{item.store || 'Any Store'}}, {{item.location || 'Any Location'}}</div>
                                    @if(item.notes) {<div class="text-sm font-light capitalize">{{item.notes}}</div>}
                                    @if(item.images?.length) {
                                        <div class="flex flex-wrap gap-2 mt-2">
                                            @for(image of item.images; track $index; let i = $index) {
                                                <p-image [imageStyle]="{'border-radius': '8px', 'width': '60px', 'height': '60px'}" [src]="image?.downloadUrl" alt="Image" width="60" height="60" [preview]="true" />
                                            }
                                        </div>
                                    }
                                </div>
                                <div class="flex gap-2">
                                    <p-button
                                        icon="pi pi-pen-to-square" 
                                        severity="secondary" 
                                        [outlined]="true"
                                        (click)="edit(item)" />
                                    <p-button
                                        icon="pi pi-times" 
                                        severity="danger"
                                        [outlined]="true"
                                        (click)="delete(item.id || '')" />
                                </div>
                            </div>
                        }
                    </div>
                } @empty {
                    <div class="p-4 pt-12">
                        <p-message severity="info">Looks like your shopping list is empty! Keep adding items easily by texting or talking to me whenever you think of something.</p-message>
                        <div class="w-full flex items-center justify-center py-4">
                            <p-button
                                (click)="addItemToCart()"
                                [label]="'Add item to shopping list'"
                                class="w-full [&_button]:w-full [&_button]:bg-green-500 [&_button]:border-0 [&_button]:text-white" />
                        </div>
                    </div>
                    
                }
            } @else {
                <div class="flex w-full justify-center">
                    <p-progress-spinner ariaLabel="loading" strokeWidth="4" [style]="{ width: '50px', height: '50px' }" />
                </div>
            }
        </div>
        <div class="pb-16">
            <p-panel header="Quickly add items from your recent orders" [expandIcon]="'pi pi-chevron-down'"
                [collapseIcon]="'pi pi-chevron-up'" [toggler]="'header'" [toggleable]="true" [collapsed]="false">
                <div class="flex flex-wrap gap-2">
                    @for (item of filteredUserGroceryHistoryData; track $index) {
                        <div class="py-1 px-4 gap-2 rounded-2xl border-0 bg-orange-100 flex-shrink-0 w-[48%]"
                            (click)="onGrocerySuggestionSelection(item)">{{item.name}} @if(item.orderedOn){ <div style="font-size: 8px;">Ordered
                                on {{item.orderedOn | date: 'MM/dd/YYYY'}}</div>}</div>
                    } @empty {
                        @if (userGroceryHistoryData.length > 0) {
                            <div class="py-2 text-gray-500 ">All items from you previous orders are already in your shopping list!</div>
                        } @else {
                            <div class="py-2 text-gray-500 ">No orders yet. As you keep ordering, we learn and make building your shopping list effortless -- we're just waiting to wow you! </div>
                        }
                    }
                </div>
            </p-panel>
        </div>

        <div class="fixed bottom-0 left-0 right-0 p-2 bg-green-100">
            <p-button
                [disabled]="cartItems.length === 0"
                (click)="checkout()"
                [label]="'Checkout'"
                [disabled]="preCheckoutChecksInProcessing"
                [loading]="preCheckoutChecksInProcessing"
                [style]="{background: '#4D7935'}"
                class="[&_button]:w-full [&_button]:border-0 [&_button]:text-white" />
        </div>
    } @else if(step === 'checkout') {
        <!-- <p-stepper [value]="stepperValue">
            <p-step-item [value]="1">
                <p-step>Delivery Details</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        @for (address of userPreviousAddresses; track $index) {
                            <div class="mb-2" >
                                <div (click)="selectedDeliveryAddress = address; showAddressForm = false" [ngClass]="selectedDeliveryAddress?.fullAddress == address.fullAddress ? 'border-2 bg-green-50 border-green-500' : 'bg-white border-gray-100'" class="text-sm font-semibold p-3 border bg-white rounded-lg">{{address.fullAddress}}</div>
                            </div>
                            
                        }
                        @if(userPreviousAddresses.length > 0 && !showAddressForm) {
                            <div>
                                <p-button
                                    [icon]="'pi pi-plus'"
                                    [size]="'small'"
                                    [style]="{background: 'rgb(209.8448275862, 230.3275862069, 198.6724137931)', 'border-color': '#4D7935'}"
                                    class="[&_button]:text-gray-700 [&_button]:border-2 [&_button]:w-full"
                                    label="Add New Address"
                                    (onClick)="showAddressForm = true; selectedDeliveryAddress = undefined" />
                            </div>
                        }
                        @if(showAddressForm) {
                            <div class="flex flex-col">
                                <div class="border-1 rounded-xl bg-green-50 p-4 ">
                                    <form [formGroup]="deliveryAddressformGroup">
                                        <p-floatlabel variant="in" class="mb-2">
                                            <input pInputText id="street_address" formControlName="streetAddress" autocomplete="off" class="w-full" />
                                            <label for="street_address">Street Address</label>
                                        </p-floatlabel>
                                        <p-floatlabel variant="in"  class="mb-2">
                                            <p-select formControlName="city" inputId="city" [options]="cities" optionLabel="name" class="w-full"/>
                                            <label for="city">City</label>
                                        </p-floatlabel>
                                        <p-floatlabel variant="in" class="mb-2">
                                            <input pInputText id="zipcode" formControlName="zipcode" autocomplete="off" class="w-full"/>
                                            <label for="zipcode">Zipcode</label>
                                        </p-floatlabel>
                                    </form>
                                    
                                </div>
                            </div>
                        }
                        
                        <div class="flex py-6 gap-2">
                            <p-button
                                [style]="{background: '#4D7935'}"
                                class="[&_button]:text-white [&_button]:border-0"
                              label="Next" [disabled]="!(selectedDeliveryAddress || deliveryAddressformGroup.valid)" (onClick)="activateCallback(2)" />
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <p-step-item [value]="2">
                <p-step>Payment Method</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col">
                                <div class="border-1  rounded-xl bg-green-50 p-4 ">
                                    <app-payments (paymentMethodChanged)="onPaymentMethodChange($event)" (paymentAdded)="onPaymentMethodAdded($event); activateCallback(3)" [openedInDialog]="false"></app-payments>
                                </div>
                        </div>
                        <div class="flex py-6 gap-2">
                            <p-button label="Back" severity="secondary" (onClick)="activateCallback(1)" />
                            <p-button [style]="{background: '#4D7935'}" #paymentNextBtn
                            class="[&_button]:text-white [&_button]:border-0" label="Next" (onClick)="activateCallback(3)" />
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <p-step-item [value]="3">
                <p-step>Shopping List Summary</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col">
                            <div class="border-1 rounded-xl bg-green-50 p-4 ">
                                @if(groupedCartItems$ | async; as groupedCartItems) {
                                    @for (group of groupedCartItems | keyvalue; track group) {
                                        <div class="mb-2">
                                            @if(storeCount > 1) {<div class="text-xs text-gray-700 text-bold">{{group.key}}</div>}
                                            @for (item of group.value; track item.id) {
                                                <div class="p-3 border-bottom-1 border-gray-300 flex flex-row justify-content-between">
                                                    <div class="flex-1">
                                                        <div class="font-medium text-sm"><span class="capitalize">{{ item.name }}</span></div>
                                                        <div class="text-sm font-light capitalize">@if(item.quantity){<span>{{item.quantity + ' ' + item.unit}}, </span>}{{item.store || 'Any Store'}}{{item.location ? ', ': ''}}{{item.location}}</div>
                                                        @if(item.notes) {<div class="text-sm font-light capitalize">{{item.notes}}</div>}
                                                    </div>
                                                    <div class="flex gap-2">
                                                        <p-button
                                                            icon="pi pi-pen-to-square" 
                                                            severity="primary" 
                                                            [outlined]="true"
                                                            [style]="{border: 0}"
                                                            (click)="edit(item)" />
                                                        <p-button
                                                            icon="pi pi-times" 
                                                            severity="danger"
                                                            [outlined]="true"
                                                            [style]="{border: 0}"
                                                            (click)="delete(item.id || '')" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="flex py-6 gap-2">
                            <p-button label="Back" severity="secondary" (onClick)="activateCallback(2)" />
                            <p-button [style]="{background: '#4D7935'}"
                            class="[&_button]:text-white [&_button]:border-0"label="Next" [disabled]="!hasCartItems" (onClick)="activateCallback(4)" />
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
            

            <p-step-item [value]="4">
                <p-step>Order Summary</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="flex flex-col">
                            <div class="border-1 rounded-xl bg-green-50 p-4 ">
                                <div class="capitalize text-sm pt-1 flex justify-between"><div class="text-gray-700 mr-3">Address</div></div>
                                <div class="text-sm pb-1 flex justify-between font-semibold">{{selectedDeliveryAddress?.fullAddress || (deliveryAddressformGroup.valid ? getDeliveryAddress() : 'Please provide delivery address')}}</div>
                                <div class="capitalize text-sm pt-1 flex justify-between"><div class="text-gray-700 mr-3">Payment Method</div></div>
                                <div class="text-sm pb-1 flex justify-between font-semibold">Ending in {{selectedPaymentMethod?.card?.last4}}</div>
                                <div class="capitalize text-sm py-1 pb-5 flex justify-between"><div class="text-gray-700 mr-3">Estimated Delivery Time:</div> <div class="font-semibold">Before 7PM</div></div>
                                
                                <div class="text-sm py-1 pb-5 flex justify-between">
                                    <div class="text-gray-700 mr-3">
                                        <div>Tip:</div>
                                        <div class="text-xs text-gray-500 italic">100% goes to the rider</div>
                                    </div>
                                    <p-inputnumber class="w-12 [&_input]:w-12" [maxFractionDigits]="0"  [formControl]="tip" inputId="tip" mode="currency" currency="USD" locale="en-US" />
                                </div>

                                <div class="capitalize text-sm pt-1 flex justify-between"><div class="text-gray-700 mr-3">Items Cost:</div><div class="font-semibold">Store receipt</div></div>
                                <div class="text-xs pb-1 flex justify-between"><div class="text-gray-500 mr-3 italic ">We do not add any markups</div></div>
                                <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3">Shopping Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.shoppingFee}}</div></div>
                                <div class="text-xs pb-1 flex justify-between"><div class="text-gray-500 mr-3 italic ">For the time spent shopping your items</div></div>
                                @if(orderPricingMetrics.multiStoreShoppingFee > 0){<div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3 ml-4">Multi Store Shopping Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.multiStoreShoppingFee}}</div></div>}

                                <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3">Delivery Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.deliveryFee}}</div></div>
                                @if(orderPricingMetrics.multiStoreDeliveryFee > 0){<div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3 ml-4">Multi Store Delivery Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.multiStoreDeliveryFee}}</div></div>}

                                <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3">Platform Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.serviceFee}}</div></div>
                                <div class="text-xs pb-1 flex justify-between"><div class="text-gray-500 mr-3 italic ">To run this platform and provide you affordable services</div></div>

                                <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3">Total Cost:</div> <div class="font-semibold">Items Cost + ${{orderPricingMetrics.totalFee + ((tip.value || 0) * 1)}}</div></div>
                            </div>
                            <p-message class="my-2 text-xs" size="small" severity="warn" [innerHTML]="'We deliver at store prices. No hidden fees. <b>Note: We do not delivery alcohol or age restricted items even if they are listed in the order.</b>'"></p-message>
                        </div>
                        <div class="flex py-6 gap-2">
                            <p-button label="Back" severity="secondary" (onClick)="activateCallback(3)" />
                            <p-button 
                                [style]="{background: '#4D7935'}"
                                class="[&_button]:text-white [&_button]:border-0"
                                label="Place Order" 
                                [disabled]="!(selectedDeliveryAddress || deliveryAddressformGroup.valid) || !hasPaymentMethods || !hasCartItems || placingOrderInProgress" 
                                [loading]="placingOrderInProgress"
                                (onClick)="placeOrder()" />
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
        </p-stepper> -->


        <p-timeline [value]="checkoutSteps" layout="vertical" styleClass="customized-timeline">
            <ng-template #marker let-event>
                <span class="flex min-w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm" [ngClass]="{ 'bg-green-500': event.completed, 'bg-green-50': !event.completed }">
                    <i [class]="event.icon"></i>
                </span>
            </ng-template>
            <ng-template #content let-event>
                @if(event.name === 'address') {
                    <div class="font-semibold pt-1 pb-3">Delivery Address</div>
                    @for (address of userPreviousAddresses; track $index) {
                        <div class="mb-2" >
                            <div (click)="selectedDeliveryAddress = address; showAddressForm = false" [ngClass]="selectedDeliveryAddress?.uid == address.uid ? 'border border-green-500' : ''" class="text-sm font-semibold p-3 border rounded-lg flex items-center gap-2">
                                <div>{{address.fullAddress}}</div>
                                <div>
                                    <p-button
                                        icon="pi pi-times" 
                                        severity="danger"
                                        [outlined]="true"
                                        (click)="deleteAddress(address.uid || '')" />
                                </div>
                            </div>
                        </div>
                    }
                    @if(userPreviousAddresses.length > 0 && !showAddressForm) {
                        <div>
                            <p-button
                                [icon]="'pi pi-plus'"
                                [size]="'small'"
                                [style]="{background: 'transparent', 'border-color': '#4D7935'}"
                                class="[&_button]:text-gray-700 [&_button]:border-1 [&_button]:w-full"
                                label="Add New Address"
                                (onClick)="showAddressForm = true; selectedDeliveryAddress = undefined" />
                        </div>
                    }
                    @if(showAddressForm) {
                        <div class="flex flex-col" style="
                            padding: 16px 16px 0;
                            border: 1px solid green;
                            border-radius: 8px;
                        ">
                            <div>New Address</div>
                            <div class="border-1 rounded-xl py-4 ">
                                @if(deliveryAddressformGroup){
                                    <form [formGroup]="deliveryAddressformGroup">
                                        <p-floatlabel variant="in" class="mb-2">
                                            <input pInputText id="street_address" formControlName="streetAddress" autocomplete="off" class="w-full" />
                                        <label for="street_address">Street Address</label>
                                        </p-floatlabel>
                                        <p-floatlabel variant="in"  class="mb-1">
                                            <p-select formControlName="city" inputId="city" [options]="cities" optionLabel="name" class="w-full"/>
                                            <label for="city">City</label>
                                        </p-floatlabel>
                                        <div class="text-gray-500 text-xs italic mb-2">We are serving currently in limited locations</div>
                                        <p-floatlabel variant="in" class="mb-2">
                                            <input pInputText id="zipcode" formControlName="zipcode" autocomplete="off" class="w-full"/>
                                            <label for="zipcode">Zipcode</label>
                                        </p-floatlabel>
                                    </form>
                                }
                                
                                <p-button 
                                    [style]="{background: '#4D7935', width: '100%'}"
                                    class="w-full mt-2 [&_button]:text-white [&_button]:border-0"
                                    label="Add Address" 
                                    [disabled]="!deliveryAddressformGroup?.valid" 
                                    (onClick)="saveAddress()" />
                            </div>
                        </div>
                    }
                } @else if (event.name === 'payment') {
                    <div class="font-semibold pt-1 pb-3">Payment Method</div>

                    <div class="flex flex-col">
                        <div class="border-1  rounded-xl">
                            <app-payments (paymentMethodChanged)="onPaymentMethodChange($event)" (paymentAdded)="onPaymentMethodAdded($event)" [openedInDialog]="false"></app-payments>
                        </div>
                    </div>
                } @else if (event.name === 'list') {
                    <div class="flex flex-col">
                        <div class="font-semibold pt-1 pb-3">Shopping List</div>
                        <div class="border-1 rounded-xl">
                        @if(groupedCartItems$ | async; as groupedCartItems) {
                            @for (group of groupedCartItems | keyvalue; track group) {
                                <div class="mb-2">
                                    @if(storeCount > 1) {<div class="text-xs text-gray-700 text-bold capitalize">{{group.key}}</div>}
                                    @for (item of group.value; track item.id) {
                                        <div class="py-3 border-bottom-1 border-gray-300 flex flex-row justify-content-between">
                                            <div class="flex-1">
                                                <div class="font-medium text-sm"><span class="capitalize">{{ item.name }}</span></div>
                                                <div class="text-sm font-light capitalize">@if(item.quantity){<span>{{item.quantity + ' ' + item.unit}}, </span>}{{item.store || 'Any Store'}}{{item.location ? ', ': ''}}{{item.location}}</div>
                                                @if(item.notes) {<div class="text-sm font-light capitalize">{{item.notes}}</div>}
                                                @if(item.images?.length) {
                                                    <div class="flex flex-wrap gap-2 mt-2">
                                                        @for(image of item.images; track $index; let i = $index) {
                                                            <p-image [imageStyle]="{'border-radius': '8px', 'width': '60px', 'height': '60px'}" [src]="image?.downloadUrl" alt="Image" width="60" height="60" [preview]="true" />
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            <div class="flex gap-2">
                                                <p-button
                                                    icon="pi pi-pen-to-square" 
                                                    severity="primary" 
                                                    [outlined]="true"
                                                    [style]="{border: 0}"
                                                    (click)="edit(item)" />
                                                <p-button
                                                    icon="pi pi-times" 
                                                    severity="danger"
                                                    [outlined]="true"
                                                    [style]="{border: 0}"
                                                    (click)="delete(item.id || '')" />
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        }
                        </div>
                    </div>
                } @else if (event.name === 'summary') {
                    <div class="flex flex-col">
                        <div class="font-semibold pt-1 pb-3">Summary</div>
                        <div class="border-1 rounded-xl">
                            <div class="capitalize text-sm pt-1 flex justify-between"><div class="text-gray-700 mr-3">Address</div></div>
                            <div class="text-sm pb-3 flex justify-between font-semibold">{{selectedDeliveryAddress?.fullAddress || 'Please add delivery address above to see final summary'}}</div>
                            <div class="capitalize text-sm pt-1 flex justify-between"><div class="text-gray-700 mr-3">Payment Method</div></div>
                            <div class="text-sm pb-3 flex justify-between font-semibold">Ending in {{selectedPaymentMethod?.card?.last4}}</div>
                            <div class="capitalize text-sm  flex justify-between"><div class="text-gray-700 mr-3">Est. Delivery Time:</div></div>
                            <div class="text-sm pb-5 flex justify-between font-semibold">{{estimatedDeliveryTime}}</div>

                            <div class="text-sm py-1 pb-5 flex justify-between">
                                <div class="text-gray-700 mr-3">
                                    <div>Tip:</div>
                                    <div class="text-xs text-gray-500 italic">100% goes to shopper</div>
                                </div>
                                <p-inputnumber class="w-12 [&_input]:w-12" [maxFractionDigits]="0"  [formControl]="tip" inputId="tip" mode="currency" currency="USD" locale="en-US" />
                            </div>

                            <div class="capitalize text-sm pt-1 flex justify-between"><div class="text-gray-700 mr-3">Items Cost:</div><div class="font-semibold">Store receipt</div></div>
                            <div class="text-xs pb-2 flex justify-between"><div class="text-gray-500 mr-3 italic ">We do not add any markups</div></div>
                            <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3">Shopping Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.shoppingFee.toFixed(2)}}</div></div>
                            <div class="text-xs pb-2 flex justify-between"><div class="text-gray-500 mr-3 italic ">For the time spent shopping your items</div></div>
                            @if(orderPricingMetrics.multiStoreShoppingFee > 0){
                                <div class="capitalize text-sm py-1 flex justify-between">
                                    <div class="text-gray-700 mr-3 ml-4">Multi Store Shopping Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.multiStoreShoppingFee.toFixed(2)}}</div>
                                </div>
                                <div class="text-xs pb-2 flex justify-between"><div class="text-gray-500 mr-3 ml-4 italic ">Additional ${{pricingMetrics?.shoppingFee?.perAdditionalStore}} per store</div></div>
                            }
                            <!-- @if(orderPricingMetrics.farApartStoresFee > 0){
                                <div class="capitalize text-sm py-1 flex justify-between">
                                    <div class="text-gray-700 mr-3 ml-4">Long Distance Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.farApartStoresFee.toFixed(2)}}</div>
                                </div>
                                <div class="text-xs text-gray-700 mr-3 ml-4">Travel Distance: {{orderPricingMetrics.totalDistance.toFixed(0)}} mi, Travel Time: {{orderPricingMetrics.totalTravelTime.toFixed(0)}} mins</div>
                                <div class="text-xs pb-1 flex justify-between"><div class="text-gray-500 mr-3 ml-4 italic ">When stores are far from each other and delivery location</div></div>
                            } -->

                            <div class="capitalize text-sm py-1 pb-2 flex justify-between"><div class="text-gray-700 mr-3">Delivery Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.deliveryFee.toFixed(2)}}</div></div>
                            @if(orderPricingMetrics.farApartStoresFee > 0){
                                <div class="capitalize text-sm py-1 flex justify-between">
                                    <div class="text-gray-700 mr-3">Long Distance Fee: <span class="text-xs text-gray-500 italic">({{orderPricingMetrics.totalDistance.toFixed(0)}} mi, {{orderPricingMetrics.totalTravelTime.toFixed(0)}} mins)</span></div>
                                    <div class="font-semibold"> ${{orderPricingMetrics.farApartStoresFee.toFixed(2)}}</div>
                                </div>
                                <div class="text-xs pb-2 flex justify-between">
                                    <div class="text-gray-500 mr-3 italic ">100% goes to shopper — supporting fair pay for their gas and time..</div>
                                </div>
                            }

                            @if(orderPricingMetrics.multiStoreDeliveryFee > 0){
                                <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3 ml-4">Multi Stores Delivery Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.multiStoreDeliveryFee.toFixed(2)}}</div></div>
                                <div class="text-xs pb-2 flex justify-between"><div class="text-gray-500 mr-3 ml-4 italic ">Additional ${{pricingMetrics?.deliveryFee?.perAdditionalStore}} per store</div></div>
                            }

                            <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3">Platform Fee:</div><div class="font-semibold"> ${{orderPricingMetrics.serviceFee.toFixed(2)}}</div></div>
                            <div class="text-xs pb-2 flex justify-between"><div class="text-gray-500 mr-3 italic ">To run this platform and offer services that work for everyone — fairly and transparently</div></div>

                            <!-- <div class="capitalize text-sm py-1 flex justify-between"><div class="text-gray-700 mr-3">Estimated Tax:</div><div> $2</div></div> -->
                            <div class="capitalize text-lg py-3 flex justify-between"><div class="text-gray-700 mr-3">Total Cost:</div> <div class="font-semibold">Items Cost + ${{(orderPricingMetrics.totalFee + ((tip.value || 0) * 1)).toFixed(2)}}</div></div>
                        </div>
                        <p-message class="my-2 text-xs" size="small" severity="warn" [innerHTML]="'We deliver at store prices. No hidden fees. <b>Note: We do not delivery alcohol and age restricted items.</b>'"></p-message>
                    </div>
                    <p-accordion value="0">
                        <p-accordion-panel value="-1">
                            <p-accordion-header>
                                <ng-template #toggleicon let-active="active">
                                    @if (active) {
                                        <i class="pi pi-chevron-circle-down"></i>
                                    } @else {
                                        <i class="pi pi-chevron-circle-up"></i>
                                    }
                                </ng-template>
                                <span class="flex items-center gap-2 w-full">
                                    <i class="pi pi-wallet"></i>
                                    <span class="font-bold whitespace-nowrap text-xs">What You Save with AnyStore</span>
                                </span>
                            </p-accordion-header>
                            <p-accordion-content>
                                <p class="mb-3 pt-2 text-xs flex justify-start items-center gap-2">
                                    <i class="pi pi-clock"></i>
                                    <span class="text-xs">{{
                                        (
                                            Math.floor(
                                                (
                                                    ((orderPricingMetrics.totalTravelTime || 0) + (storeCount * 15)) / 10
                                                ) 
                                            ) * 10
                                        )
                                    }}–{{
                                        (
                                            Math.ceil(
                                                (
                                                    ((orderPricingMetrics.totalTravelTime || 0) + (storeCount * 15)) / 10
                                                ) 
                                            ) * 10
                                        )
                                    }} minutes of your day</span>
                                </p>
                                <p class="mb-3 text-xs flex justify-start items-center gap-2">
                                    <i class="pi pi-car"></i>
                                    <span  class="text-xs">{{storeCount > 1 ? '$3–$4 ' : '$2–$3 '}}in gas</span>
                                </p>
                                <p class="mb-3 text-xs flex justify-start items-center gap-2">
                                    <i class="pi pi-shopping-cart"></i>
                                    <span class="text-xs">Parking, crowds, checkout lines, stress</span>
                                </p>
                                <p class="mb-3 text-xs flex justify-start items-center gap-2">
                                    <!-- <i class="pi pi-clock"></i> -->
                                    <span class="text-xs">And peace of mind — knowing you’re only paying for what’s real. No hidden fees. No markups.</span>
                                </p>
                                <p class="py-2 text-xs font-bold">
                                    ✅ All for just ${{(orderPricingMetrics.totalFee + ((tip.value || 0) * 1)).toFixed(2)}} flat
                                </p>
                            </p-accordion-content>
                        </p-accordion-panel>
                    </p-accordion>
                    <div class="flex py-6 gap-2">
                        <p-button 
                            [style]="{background: '#4D7935', width: '100%'}"
                            class="w-full [&_button]:text-white [&_button]:border-0"
                            label="Place Order" 
                            [disabled]="!(selectedDeliveryAddress || deliveryAddressformGroup?.valid) || !hasPaymentMethods || !hasCartItems || placingOrderInProgress" 
                            [loading]="placingOrderInProgress"
                            (onClick)="placeOrder()" />
                    </div>
                }
            </ng-template>
        </p-timeline>
    }
    
</div>


